<template>
  <div class="maandWieber" :class="[maand.status, maand.naam]" @click="selectMonth" :title="title">
    <div class="content" v-if="maand.status !== 'active'">
      <span class="maand">{{ miniMaand}}</span>
      <span class="line">
        <img src="../assets/2.png">
      </span>
    </div>
    <div class="activewieber" v-else>
      <div class="content">
        <span class="maand">{{ maand.naam }}</span>

        <span class="jaar">{{ maand.jaar }}</span>
      </div>

      <div class="bar" :class="{ last: maand.last}">
        <span class="dwarslijn"></span>
      </div>
    </div>
  </div>
</template>
<style  scoped>
/* non-mobile */

.maandWieber {
  color: #55574A;
  /* color: #f0eeea; */
  width: 40px;
  height: 40px;
  left: 0px;
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.15);
  background: rgba(240, 238, 234, 0.5);
  cursor: not-allowed;
  transform: rotate(-90deg);
  margin-left: -20px;
}
.maandWieber .maand {
  display: none;
}
.juni {
  margin-top: 5px;
}
.mei {
  margin-bottom: 5px;
}

.content {
  width: 100%;
  height: 100%;
  text-transform: capitalize;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  font-weight: bold;
}

.maand {
  font-family: RijksoverheidSansText, sans-serif;
  font-size: 14px;
  line-height: 15px;
  /* identical to box height */
  text-align: center;
}
.jaar {
  font-family: BornReady;
  font-size: 20px;
  text-align: center;
  font-weight: 100;
  color: #55574A;
  /* color: #f0eeea; */
}
.line {
  border-top: solid 2px #55574A;
  width: 40px;
  height: 2px;
  display: inline-block;
  margin-top: 20px;
}
.mei .line {
  width: 20px;
  margin-left: 20px;
}

.dwarslijn {
  width: 2px;
  height: 90px;
  display: block;
  margin-left: 6px;
  border-right: solid 2px #55574A;
}
img {
  position: relative;
  left: 50%;
  top: -11px;
}
.mei img {
  left: 0%;
}
.enabled {
  background: rgba(241, 142, 5, 0.8);
  cursor: pointer;
  transition: background 100ms;
}
.enabled:hover {
  background: rgba(241, 142, 5, 1);
}
.enabled:active {
  background: rgba(241, 142, 5, 0.8);
}
.maandWieber.active {
  margin-left: 0px;
}

.active {
  color: #f0eeea;
  background: url("../assets/active-mobile.svg");
  width: 40px;
  height: 90px;
  left: 77px;
  top: 155px;
  box-shadow: none;
  transform: none;
  z-index: 1000;
  display: inline-block;
}
.active .img{

}
.active .content {
  transform: rotate(-90deg);
}
.active .maand {
  font-size: 11px;
  line-height: 25px;
}
.active .jaar {
    color: #f0eeea;

  font-size: 13px;
  line-height: 25px;
  text-align: center;
}
.vierkant {
  width: 40px;
  height: 55px;
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.15);
}
.bar {
  color: #55574A;
  width: 20px;
  height: 90px;
  top: 4px;
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.15);
  background: rgba(241, 142, 5, 0.8);

  position: relative;

  z-index: -100;
}
.bar.last {
  background: rgba(240, 238, 234, 0.5);
}
.driehoek {
  width: 0;
  height: 0;

  border-right: 40px solid transparent;
  z-index: 2;
}
.driehoek:after {
  position: absolute;
  z-index: 1;
  content: "";
  width: 45px;
  height: 2px;
  background: none;
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.5);

  transform: rotate(-42deg) translateX(0px) translateY(-17px);
}

.active .content {
  float: left;
  font-weight: bold;
  justify-content: flex-start;
}
.active .maand {
  display: block;
}
.active .line {
  top: -5px;
  margin-top: -5px;
  width: 90px;
  border-top: none;
}
.active img {
  top: -5px;
}

@media (min-width: 768px) {
  .maandWieber {
    margin-left: 0px;
  }
  .maandWieber .maand {
    display: block;
  }
  .line {
    margin-top: 0px;
  }
  img {
    top: -11px;
  }
  .dwarslijn {
    margin-left: 29px;
  }
  .active {
    width: 77px;

    background: url("../assets/active.svg");
  }
  .bar {
    width: 40px;
  }
  .active .content {
    transform: rotate(0deg);
    font-size: 14px;
    line-height: 15px;
  }
  .active .jaar {
    font-size: 20px;
    line-height: 34px;
  }
  .active .maand {
    font-size: 14px;
    line-height: 34px;
  }
  .vierkant {
    width: 77px;
  }
  .driehoek {
    border-right: 77px solid transparent;
  }
  .driehoek:after {
    width: 80px;

    transform: rotate(-24deg) translateX(0px) translateY(-20px);
  }
}
</style>

<script>
/**
  Componentje voor de maand wieber, heeft drie states: beschibaar, actief en niet beschikbaar.
  beschikbaar: het verhaal/kaart van deze maand is beschikbaar: oranje
  actief: het verhaal/kaart van deze maand wordt momenteel getoond
  niet beschikbaar: het verhaal/kaart van deze maand is nog niet ontsloten

  Als hij actief is en in verhaal modus dan toont hij de voortgang van het verhaal in een verloopje

  beschikbare maanden zijn klikbaar en laden het verhaal/kaart (afhankelijk of men in verhaal of kaart modus zit) van die maand
 */

function daysBetween(date) {
  const startDate = new Date('1944/6/1')
  const endDate = new Date(date)
  var millisecondsPerDay = 24 * 60 * 60 * 1000;
  return Math.round((endDate - startDate)  / millisecondsPerDay) ;
}
export default {
  props: ["maand"],
  name: "MaandWieber",
  data: function() {
    return {
      miniMaand: this.maand.naam.slice(0, 3)
    };
  },
  computed: {
    title() {
      let text = this.$route.name === "verhaal" ? "het verhaal" : "de kaart";
      let result = "";
      switch (this.maand.status) {
        case "enabled":
          result = `Klik hier om ${text} van ${this.maand.naam} te bekijken`;
          break;
        case "disabled":
          result = `Kom in ${this.maand.naam} ${this.maand.jaar + 75} terug om ${text} te bekijken`;
          break;
        default:
          result = `Je kijkt nu naar ${text} van ${this.maand.naam}`;
          break;
      }
      return result;
    }
  },
  methods: {
    selectMonth: function() {
      if (this.maand.status === "enabled") {
        let name = this.$route.name;
        this.$router.push({ name: name, params: { month: this.maand.naam } });
        if(this.maand.id !== new Date().getMonth()+1) {

          this.$store.commit('map/setCounter',daysBetween(`${this.maand.jaar}-${this.maand.id}-${this.maand.dagen}`))
        }
        else {
          this.$store.commit('map/setCounter',daysBetween(`${this.maand.jaar}-${this.maand.id}-${new Date().getDate()}`))
        }
      }
    }
  }
};
</script>